import DialogsPlugin from "../dialogsPlugin";

const AlertDialog = {
    template: "<modal ref=\"dialog\"><template slot=\"cancelButton\">&nbsp;</template></modal>",
    beforeMount() {
        DialogsPlugin.alertBus.$on("show", params => {
            this.$refs.dialog.show(params).done(res => DialogsPlugin.alertBus.$emit("close", res));
        });
    }
};

export default AlertDialog;